import createGlobalState from "@ui/lib/createGlobalState";
import * as io from "io-ts";

export const useShowIntermediateCalculations = createGlobalState({
  storage: "session",
  key: "showIntermediateCalculations",
  type: io.boolean,
  defaultValue: false,
  scoped: true,
});
